export default [function () {
    this.showModal = false;
    this.config = {
        event: {},
        maximumGuests: undefined,
        gender: undefined,
        time: {}
    };

    const show = () => {
        this.showModal = true;
    };

    const hide = () => {
        this.showModal = false;
    };

    const getState = () => {
        return this.showModal;
    };

    const setConfig = config => {
        this.config = config;
    };

    const getConfig = (param = null) => {
        if (param) {
            return this.config[param];
        }

        return this.config;
    };

    return {
        show,
        hide,
        getState,
        setConfig,
        getConfig
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/services/guest.modal.service.js